<div class="page-layout carded left-sidenav toolbar-fixed-layout">

    <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
        <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-row justify-start items-center">
            <particle-select-basket class="m-r-20" (basketChange)="onBasketChange($event)"></particle-select-basket>
        </div>
    </div>

    <mat-sidenav-container>

        <!-- CENTER -->
        <div class="center">

            <!-- CONTENT CARD -->
            <!--            <div particleHelpNotes helpNoteId="dac6-pre-arrangement" class="content-card mat-white-bg">-->
            <!-- CONTENT TOOLBAR -->


            <div class="content  pos-relative flex flex-col full-grow-no-shrink-no-basis">
                <particle-document-viewer
                        *ngIf="documentDefinitionId && documentDefinitionId.length"
                        particleHelpNotes helpNoteId="chapters"
                        [documentDefinitionId]='documentDefinitionId'
                        [showVersionComparison]="true"
                        [invalidateSubject]='invalidateSubject'
                >

                </particle-document-viewer>

            </div>
            <!-- / CONTENT CARD -->

        </div>
        <!-- / CENTER -->

    </mat-sidenav-container>

</div>

